export enum AgreementListActionsEnum {
  AGREEMENT_LIST_INIT_PAGE = 'AGREEMENT_LIST_INIT_PAGE',
  AGREEMENT_LIST_SET_SEARCH_VALUE = 'AGREEMENT_LIST_SET_SEARCH_VALUE',
  AGREEMENT_LIST_GET_DATA = 'AGREEMENT_LIST_GET_DATA',
  AGREEMENT_LIST_GET_DATA_NEXT_PAGE = 'AGREEMENT_LIST_GET_DATA_NEXT_PAGE',
  AGREEMENT_LIST_SET_DATA = 'AGREEMENT_LIST_SET_DATA',
  AGREEMENT_LIST_SET_ORDER = 'AGREEMENT_LIST_SET_ORDER',
  AGREEMENT_LIST_FIND_KNM = 'AGREEMENT_LIST_FIND_KNM',
  AGREEMENT_LIST_SET_FIND_DATA = 'AGREEMENT_LIST_SET_FIND_DATA',
}
